import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  Icon,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Switch,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Typography,
} from '@mui/material';
import PageContainer from '../../components/container/PageContainer';
import Breadcrumb from '../../layouts/full-layout/breadcrumb/Breadcrumb';
import {
  filterAllCmdFournisseur,
  listCmdExpedition,
  updateCmdMultiStatus,
} from '../../redux/slices/commande-fournisseur.slice';
import {
  cmd_type_bg,
  CmdFbStatusBg,
  CmdFbStatusDelaisAccumul,
  CmdFournisseurStatus,
  retardExcludedStatuses,
} from '../../utils/commande.enums';
import dayjs from 'dayjs';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import CmdFbDetailsWidget from './CmdFbDetails.widget.js';

const BCrumb = [
  {
    to: '/App',
    title: 'Home',
  },
  {
    title: 'Expédition',
  },
];

const expedition_filter = {
  prevu_expedier: (arr) => {
    return arr.filter(
      (el) =>
        ![
          CmdFournisseurStatus.PRETE,
          CmdFournisseurStatus.EN_STOCK,
          CmdFournisseurStatus.A_EXPEDIE,
          CmdFournisseurStatus.LIVRE,
        ].includes(el?.status),
    );
  },
  a_expedier: (arr) => {
    return arr.filter((el) =>
      [
        CmdFournisseurStatus.PRETE,
        CmdFournisseurStatus.EN_STOCK,
        CmdFournisseurStatus.A_EXPEDIE,
      ].includes(el?.status),
    );
  },
  expediee: (arr) => {
    return arr.filter((el) => [CmdFournisseurStatus.LIVRE].includes(el?.status));
  },
};
const CmdExpeditionListContainer = () => {
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.cmd_achat_store);
  const [lst_cmd, set_lst_cmd] = useState([]);
  const [sel_item, set_sel_item] = useState(null);
  const [show_details, set_show_details] = useState(false);
  const [search, set_search] = useState('');
  const [sel_tab, set_sel_tab] = useState(0);

  const [lst_prevu_expedier, set_lst_prevu_expedier] = useState([]);
  const [lst_a_expedier, set_lst_a_expedier] = useState([]);
  const [lst_expediee, set_lst_expediee] = useState([]);

  const load_data = () => {
    dispatch(listCmdExpedition())
      .unwrap()
      .then((res) => {
        if (Array.isArray(res)) {
          set_lst_prevu_expedier(expedition_filter.prevu_expedier(res));
          set_lst_a_expedier(expedition_filter.a_expedier(res));
          set_lst_expediee(expedition_filter.expediee(res));
          set_lst_cmd(res);

          if (sel_item) {
            set_sel_item(res.find((el) => el?.ref == sel_item?.ref));
          }
        }
      })
      .catch((err) => console.log(err));
  };

  const onFilter = () => {
    if (Array.isArray(lst_cmd)) {
      let s = String(search).toLowerCase()
      let tmp = lst_cmd.filter(
        (el) =>
          String(el?.ref).toLowerCase().includes(s) ||
          String(el?.client?.nom).toLowerCase().includes(s) ||
          String(el?.client?.prenom).toLowerCase().includes(s) ||
          String(el?.catalogue?.sku).toLowerCase().includes(s) ||
          String(el?.catalogue?.nom).toLowerCase().includes(s) ||
          String(el?.status).toLowerCase().includes(s)
      );

      set_lst_prevu_expedier(expedition_filter.prevu_expedier(tmp));
      set_lst_a_expedier(expedition_filter.a_expedier(tmp));
      set_lst_expediee(expedition_filter.expediee(tmp));
    }
  };

  const onUpdateMultiStatus = (ids, status) => {
    if (Array.isArray(ids) && status)
      dispatch(updateCmdMultiStatus({ ids, status }))
        .unwrap()
        .then((res) => {
          load_data();
        })
        .catch((err) => console.log(err));
  };

  const onShowDetails = (data) => {
    set_sel_item(data);
    set_show_details(true);
  };
  const onCloseDetails = () => {
    set_sel_item(null);
    set_show_details(false);
  };

  useEffect(() => {
    load_data();
  }, []);

  useEffect(() => {
    onFilter();
  }, [search]);

  return (
    <PageContainer title="Les Expéditions" description="">
      {/* breadcrumb */}
      <Breadcrumb title="Les Expéditions" items={BCrumb} />
      {/* end breadcrumb */}

      {/* Search Bar  */}

      <Box>
        <TextField
          sx={{ my: 2 }}
          size="small"
          fullWidth
          placeholder="Par (Num Commande , Client , sku , status ... )"
          label="Rechercher"
          value={search}
          onChange={(e) => set_search(e?.target?.value)}
        />
      </Box>

      {/* Tabs  */}
      <Tabs value={sel_tab} onChange={(e, val) => set_sel_tab(val)}>
        <Tab label={`📦 Prévu à expédier (${lst_prevu_expedier.length})`} />
        <Tab label={`🕒 À expédier (${lst_a_expedier.length})`} />
        <Tab label={`✅ Expédiée (${lst_expediee.length})`} />
      </Tabs>

      {/* List Form */}
      <ExpeditionList
        loading={loading}
        error={error}
        lst_items={sel_tab == 0 ? lst_prevu_expedier : sel_tab == 1 ? lst_a_expedier : lst_expediee}
        onShowCmdDetails={onShowDetails}
        onUpdateMultiStatus={onUpdateMultiStatus}
        sel_tab={sel_tab}
      />

      <CmdFbDetailsWidget
        idCmdFournisseur={sel_item?.idCmdFournisseur}
        show={show_details}
        onClose={onCloseDetails}
      />
    </PageContainer>
  );
};

const ExpeditionList = ({
  lst_items,
  loading,
  error,
  onShowCmdDetails,
  onUpdateMultiStatus,
  sel_tab,
}) => {
  const [lst_expedition, set_lst_expedition] = useState([]);

  const onConfirmExpedition = () => {
    if (Array.isArray(lst_expedition) && lst_expedition.filter((el) => el.checked).length > 0) {
      onUpdateMultiStatus(
        lst_expedition.filter((el) => el.checked).map((el) => el.idCmdFournisseur),
        CmdFournisseurStatus.LIVRE,
      );
    }
  };

  const onCheckItem = (value, ref) => {
    if (Array.isArray(lst_expedition))
      set_lst_expedition(
        lst_expedition.map((el) => (el?.ref == ref ? { ...el, checked: value } : el)),
      );
  };

  useEffect(() => {
    set_lst_expedition(
      Array.isArray(lst_items) ? lst_items.map((el) => ({ ...el, checked: false })) : [],
    );
  }, [lst_items]);

  return (
    <div style={{ marginTop: '20px' }}>
      <Box textAlign={'end'}>
        {sel_tab === 1 && (
          <Button
            onClick={onConfirmExpedition}
            disabled={lst_expedition.filter((el) => el.checked).length == 0 || loading}
            variant="outlined"
            color="success"
            sx={{ px: 3 }}
          >
            Mettre expédiée
          </Button>
        )}
      </Box>

      <TableContainer>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              {sel_tab === 1 && <TableCell></TableCell>}
              <TableCell>Num Commande</TableCell>
              <TableCell>Article</TableCell>
              <TableCell>Client</TableCell>
              <TableCell>Adresse</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Date Prévu</TableCell>
              <TableCell>Magasin</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {lst_expedition.map((el) => (
              <ExpeditionItem
                key={el?.idCmdFournisseur}
                cmd={el}
                onCheck={onCheckItem}
                onItemClick={onShowCmdDetails}
                sel_tab={sel_tab}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

const ExpeditionItem = ({ cmd, onCheck, onItemClick, sel_tab }) => {
  const [blocage_tags, set_blocage_tags] = useState([]);
  const [is_retard, set_is_retard] = useState(false);
  const [nbr_j_retard, set_nbr_j_retard] = useState(false);

  useEffect(() => {
    if (cmd?.is_urgent && cmd?.date_urgent) {
      let date_expected = dayjs(String(cmd?.date_urgent).substring(0, 10));
      if (date_expected.isBefore(dayjs(), 'day') && cmd?.status != CmdFournisseurStatus.LIVRE) {
        set_is_retard(true);
        set_nbr_j_retard(date_expected.diff(dayjs(), 'day'));
      }
    } else {
      let date_expected = dayjs(String(cmd?.date_livraison).substring(0, 10));
      let date_creation = dayjs(String(cmd?.created_at).substring(0, 10));
      if (date_expected.isBefore(dayjs(), 'day') && cmd?.status != CmdFournisseurStatus.LIVRE) {
        set_is_retard(true);
        set_nbr_j_retard(date_expected.diff(dayjs(), 'day'));
      } else {
        if (
          date_creation
            .add(+CmdFbStatusDelaisAccumul[cmd?.status] || 0, 'day')
            .isBefore(dayjs(), 'day')
        ) {
          set_is_retard(true);
          set_nbr_j_retard(
            date_creation
              .add(+CmdFbStatusDelaisAccumul[cmd?.status] || 0, 'day')
              .diff(dayjs(), 'day'),
          );
        }
      }
    }
  }, [cmd]);

  useEffect(() => {
    if (Array.isArray(cmd?.bloquages)) {
      let tmp = cmd?.bloquages?.filter((el) => el?.status != 'resolus')?.map((el) => el?.type);
      tmp = [...new Set(tmp)];
      set_blocage_tags(tmp);
    }
  }, [cmd?.bloquages]);
  return (
    <>
      <TableRow hover>
        {sel_tab === 1 && (
          <TableCell>
            <Checkbox
              color="primary"
              checked={cmd?.selected}
              onChange={(e) => onCheck(e?.target?.checked, cmd?.ref)}
            />
          </TableCell>
        )}

        <TableCell>
          <Typography
            fontWeight={500}
            variant="subtitle2"
            color={'primary.main'}
            onClick={(e) => onItemClick(cmd)}
            sx={{ textDecoration: 'underline', cursor: 'pointer' }}
          >
            {cmd?.ref}{' '}
            {cmd?.is_urgent && (
              <Chip
                color="error"
                sx={{ pl: 0, borderRadius: '100%', borderRadius: 1, float: 'right' }}
                size="small"
                label={
                  <Icon fontSize="small">
                    <WhatshotIcon />
                  </Icon>
                }
              />
            )}
            {Array.isArray(blocage_tags) &&
              blocage_tags?.map((el) => (
                <Chip
                  color="error"
                  sx={{ pl: 0, borderRadius: 1, borderRadius: 1, mr: '2px', mt: '1px' }}
                  size="small"
                  label={`! ${el}`}
                />
              ))}
            {is_retard && !retardExcludedStatuses.includes(cmd?.status) && (
              <Chip
                color="error"
                sx={{
                  borderRadius: 1,
                  mr: '2px',
                  mt: '1px',
                  display: 'block',
                  textAlign: 'center',
                }}
                size="small"
                label={`Retard (${Math.abs(+nbr_j_retard)} J)`}
              />
            )}
          </Typography>
        </TableCell>

        <TableCell>
          <Typography fontWeight={500} variant="h6">
            {`${cmd?.catalogue?.nom} ${
              cmd?.catalogue?.groupe_model?.name
                ? `(${cmd?.catalogue?.groupe_model?.name} ${cmd?.catalogue?.groupe_model_var})`
                : ''
            }`}
          </Typography>
          <Typography fontWeight={600} variant="h6" color={'success.main'}>
            {cmd?.catalogue?.sku}
          </Typography>
        </TableCell>

        <TableCell sx={{ backgroundColor: cmd?.fournisseur?.bg_color || 'gray', color: '#fff' }}>
          <Typography fontWeight={500} variant="subtitle2" textAlign={'center'}>
            {cmd?.client ? `${cmd?.client?.nom} ${cmd?.client?.prenom}` : ''}
          </Typography>
        </TableCell>

        <TableCell>
          <Typography fontWeight={500} variant="subtitle2" textAlign={'center'}>
            {cmd?.adresse_expedition_client || '-'}
          </Typography>
        </TableCell>

        <TableCell>
          <Chip
            variant="outlined"
            label={cmd?.status || '---'}
            sx={{
              borderColor: CmdFbStatusBg?.[cmd?.status] ? CmdFbStatusBg?.[cmd?.status] : 'gray',
              color: CmdFbStatusBg?.[cmd?.status] ? CmdFbStatusBg?.[cmd?.status] : '#fff',
              borderRadius: 1,
              px: 3,
              height: '24px',
              textTransform: 'capitalize',
            }}
          />
        </TableCell>

        <TableCell>
          <Typography fontWeight={500} variant="subtitle2">
            {cmd?.is_urgent && cmd?.date_urgent
              ? String(cmd?.date_urgent).slice(0, 10)
              : cmd?.date_livraison_prevu
              ? String(cmd?.date_livraison_prevu).slice(0, 10)
              : '-'}
          </Typography>
        </TableCell>

        <TableCell
          sx={{
            backgroundColor: cmd?.magasin?.bg_color || 'gray',
            color: cmd?.magasin?.nom ? '#000' : '#fff',
          }}
        >
          <Typography fontWeight={500} variant="subtitle2" textAlign={'center'}>
            {cmd?.magasin?.code || 'central'}
          </Typography>
        </TableCell>
      </TableRow>
    </>
  );
};

export default CmdExpeditionListContainer;
